<template>
  <div>
    <div class="drop-wrapper">
      <label 
        for="file" 
        class="scan-drop" 
        @dragenter="(e) => e.preventDefault()" 
        @dragover="(e) => e.preventDefault()" 
        @dragleave="(e) => e.preventDefault()" 
        @drop="handleDrop"
      >
        <i class="fas fa-file-upload"></i>
        <span>Wybierz pliki z fakturami do dodania</span>
        <small>{{ acceptExtensions }}</small>
      </label>
      <input type="file" name="file" id="file" @change="handleChange" multiple :accept="acceptExtensions">
    </div>
    <ul>
      <li v-for="{name} in files" :key="name">{{ name }}</li>
    </ul>
    <div class="center">
      <button v-if="files.length" class="btn btn--gradient" @click="sendFiles">Skanuj!</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'scan-drop',
  data() {
    return {
      files: [],
      extensions: ['jpg', 'jpeg', 'png', 'pdf']
    }
  },
  computed: {
    acceptExtensions() {
      return this.extensions.map(el => `.${el}`).join(', ')
    }
  },
  methods: {
    handleDrop(e) {
      e.preventDefault()
      const files = e.dataTransfer.files

      let correctExtensions = 0;
      for(let i = 0; i < files.length; i++) {
        const name = files[i].name.split('.')
        
        if(this.extensions.indexOf(name[name.length-1].toLowerCase()) != -1)
          correctExtensions++
      }

      if(files.length == correctExtensions)
        this.files = files
      else
        alert("Wrong extensions!")
    },
    handleChange(e) {
      console.log(e.target.files)
      this.files = e.target.files
    },
    sendFiles() {
      this.$emit('files', this.files)
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  @extend %flex;
  margin: 16px 0 10px;
}

.drop-wrapper {
  width: calc(100% - 16px);
  box-sizing: border-box;
  margin: 8px;

  input {
    display: none;
  }
}

.scan-drop {
  border: dashed 1px $primaryColor;
  border-radius: 12px;
  padding: 8px;
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  box-sizing: border-box;
  background-color: #FCFCFC;
  transition: 0.3s;

  &:hover {
    background-color: rgba($primaryColor, 0.08);
  }

  i {
    font-size: 3em;
    color: $primaryColor;
  }

  span {
    margin: 8px 0;
  }

  small {
    font-size: 0.7em;
    color: #888;
  }
}
</style>

